"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BackButton(_ref) {
  var onClick = _ref.onClick,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? "Back" : _ref$ariaLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    variant: "ghost",
    size: "icon-sm",
    onClick: onClick,
    "aria-label": ariaLabel,
    "data-sentry-element": "Button",
    "data-sentry-component": "BackButton",
    "data-sentry-source-file": "back-button.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
      "data-sentry-element": "ArrowBackIcon",
      "data-sentry-source-file": "back-button.tsx"
    })
  });
}
var _default = exports.default = BackButton;